export const alert = {
  namespaced: true,
  state: {
    color: null,
    text: null,
    show: false
  },
  actions: {
    success({ commit, dispatch }, message) {
      commit("success", message);
      //dispatch("getNotificationList", null, { root: true });
    },
    error({ commit, dispatch }, message) {
      commit("error", message);
      //dispatch("getNotificationList", null, { root: true });
    }
  },
  mutations: {
    success(state, message) {
      state.color = "green";
      state.text = message;
      state.show = true;
    },
    error(state, message) {
      state.color = "red";
      state.text = message;
      state.show = true;
    }
  }
};
